import { CUSTOMER_CARE_WHATSAPP, PAYMENT_ACCOUNT } from '../constants/payment';
import { formatNaira } from './money';

export const buildManualPaymentWhatsAppMessage = ({ order, product }) => {
  const shippingLines = order.shipping_method ? [
    `Shipping: ${order.shipping_method}`,
    `Shipping Fee: ${formatNaira(order.shipping_fee || 0)}`,
    order.shipping_eta ? `Shipping ETA: ${order.shipping_eta}` : '',
  ].filter(Boolean).join('\n') : '';

  return [
    'I have made payment and submitted proof of payment for confirmation.',
    '',
    `Product: ${order.product_name || product?.productName || ''}`,
    `Product Image: ${order.product_image_url || product?.productImageUrl || ''}`,
    `Product Page: ${order.product_url || product?.productUrl || ''}`,
    `Product Price: ${formatNaira(order.unit_price || product?.unitPrice || 0)}`,
    `Quantity: ${order.quantity || product?.quantity || 1}`,
    `Subtotal: ${formatNaira(order.subtotal || 0)}`,
    shippingLines,
    `Total Amount Paid: ${formatNaira(order.total_amount || 0)}`,
    '',
    `Paid To: ${PAYMENT_ACCOUNT.accountName}`,
    `Bank: ${PAYMENT_ACCOUNT.bankName}`,
    `Account Number: ${PAYMENT_ACCOUNT.accountNumber}`,
    `Payment Reference: ${order.payment_reference}`,
    `Proof of Payment: ${order.proof_url}`,
  ].filter(Boolean).join('\n');
};

export const buildWhatsAppUrl = (message, phone = CUSTOMER_CARE_WHATSAPP) =>
  `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
